import { IBillingState } from './billing.types';

export const state: IBillingState = {
  loading: false,
  error: '',
};

export interface IBillingPayload {
  field: string;
  value: any;
}

export enum EBillingMutations {
  SetLoading = 'setLoading',
  SetError = 'setError',
}

export enum EBillingActions {
  Update = 'update',
  UpdateFailed = 'updateFailed',
  Validate = 'validate',
  ValidateFailed = 'validateFailed',

  ValidateError = 'validateError',
}
